import { Action, createReducer, on } from '@ngrx/store';
import * as InvitationsActions from './invitations.actions';
import { Invitations } from 'src/app/model/invitations';


export interface State {
    invitationsList: Invitations[];
    sharing: boolean;
    shared: boolean;
}

const initialState: State = {
    invitationsList: [],
    sharing: false,
    shared: false,
};

const invitationsReducer = createReducer(
    initialState,

    on(InvitationsActions.getInvitationsList, (state) => ({
        ...state,
        invitationsList: [],
    })),
    on(InvitationsActions.getInvitationsListSuccess, (state, payload) => ({
        ...state,
        invitationsList: payload.invitationsList,
    })),
    on(InvitationsActions.resetInvitationsShareDialog, (state) => ({ ...state, sharing: false, shared: false })),
    on(InvitationsActions.invitationsShareDevice, (state) => ({ ...state, sharing: true, shared: false })),
    on(InvitationsActions.invitationsShareDeviceSuccess, (state) => ({ ...state, sharing: false, shared: true })),
    on(InvitationsActions.invitationsShareDeviceFailed, (state) => ({ ...state, sharing: false, shared: false })),
    on(InvitationsActions.invitationsThGroupShare, (state) => ({ ...state, sharing: true, shared: false })),
    on(InvitationsActions.invitationsThGroupShareSuccess, (state) => ({ ...state, sharing: false, shared: true })),
    on(InvitationsActions.invitationsThGroupShareFailed, (state) => ({ ...state, sharing: false, shared: false })),
);

export const reducer = (state: State | undefined, action: Action): State => invitationsReducer(state, action);

